<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h2 matDialogTitle>Copy {{ title }}</h2>
<mat-dialog-content>
  <mat-form-field [appearance]="'outline'" [subscriptSizing]="'dynamic'">
    <input matInput readonly="true" [value]="link" data-cy="copy-link-dialog-input" />
  </mat-form-field>
  <button
    data-cy="copy-button"
    mat-icon-button
    aria-label="Copy link"
    matTooltip="Copy link"
    [cdkCopyToClipboard]="link"
    (click)="showNotification()"
  >
    <mat-icon>insert_link</mat-icon>
  </button>
</mat-dialog-content>
